import { AllHTMLAttributes, forwardRef, useState } from 'react';
import { Box, FormHelperText } from '@mui/material';
import clsx from 'clsx';
import ReactFlagsSelect from 'react-flags-select';
import { Control, Controller, ControllerProps } from 'react-hook-form';
import { ErrorFormField } from '../types';

type CountrySelectInputProps = AllHTMLAttributes<HTMLInputElement> &
  ErrorFormField & {
    onValueChange?: (str: string) => void;
  };

const CountrySelectInput = forwardRef((props: CountrySelectInputProps, ref) => {
  const { className, value, onValueChange, error, errMessage, label = 'Select a country', ...extraProps } = props;

  return (
    <Box className={clsx('flex flex-col ', className)}>
      <Box className="border-form-border-color flex h-full flex-row items-center rounded border border-solid">
        <ReactFlagsSelect
          {...extraProps}
          selected={value as string}
          onSelect={onValueChange}
          showSelectedLabel={true}
          searchable
          className="jv-country-select w-full"
          searchPlaceholder="Search countries"
          placeholder={label}
        />
      </Box>
      {error && (
        <FormHelperText className="mt-1" error={error}>
          {errMessage}
        </FormHelperText>
      )}
    </Box>
  );
});

type ControlledProps = Omit<ControllerProps, 'control' | 'render'> &
  CountrySelectInputProps & {
    control: Control<any>;
  };

export const CountrySelectInputControlled = forwardRef(({ control, name, ...props }: ControlledProps, ref) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return <CountrySelectInput {...props} ref={ref} value={value} onValueChange={onChange} error={!!error} errMessage={error?.message} />;
      }}
    />
  );
});

export default CountrySelectInput;
